import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { ManagementHistoryCopy, ManagementHistoryEntry } from '@/frontend/features/Fde/projectManagementHistoryTypes'

export default function ProjectHistoryList({ entries, selectedId, copy, busy, hasMore, onSelect, onMore }: {
  entries: ManagementHistoryEntry[]; selectedId?: string; copy: ManagementHistoryCopy; busy: boolean
  hasMore: boolean; onSelect: (id: string) => void; onMore: () => void
}) {
  return <nav aria-label={copy.updates} className="h-full overflow-y-auto overscroll-contain px-3 pb-4">
    <ol>
      {entries.map((entry, index) => {
        const day = format(parseISO(entry.occurred_at), 'yyyy-MM-dd')
        const previousDay = index > 0 ? format(parseISO(entries[index - 1].occurred_at), 'yyyy-MM-dd') : null
        return <li key={entry.id}>
          {day !== previousDay && <p className="sticky top-0 z-10 bg-background px-3 pb-2 pt-5 text-[11px] font-medium text-muted-foreground">
            {format(parseISO(entry.occurred_at), "d 'de' MMMM, yyyy", { locale: ptBR })}
          </p>}
          <button type="button" aria-current={entry.id === selectedId ? 'true' : undefined} onClick={() => onSelect(entry.id)}
            className="group mb-1 w-full rounded-md px-3 py-3 text-left hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring aria-[current=true]:bg-muted">
            {entry.category !== 'progress' && <p className="mb-1.5 text-[10px] text-muted-foreground">{copy[`category_${entry.category}`]}</p>}
            <div className="flex items-start gap-2"><p className="line-clamp-2 flex-1 break-words text-[13px] font-medium leading-5">{entry.headline}</p><ChevronRight className="mt-0.5 size-3.5 shrink-0 text-muted-foreground md:hidden" /></div>
            <div className="mt-1.5 flex items-center justify-between gap-2 text-[11px] text-muted-foreground">
              <span className="truncate">{entry.actor_name}</span><time className="shrink-0 tabular-nums" dateTime={entry.occurred_at}>{format(parseISO(entry.occurred_at), 'HH:mm')}</time>
            </div>
          </button>
        </li>
      })}
    </ol>
    {hasMore && <Button variant="ghost" size="sm" disabled={busy} className="mt-3 w-full text-xs" onClick={onMore}>{copy.older}</Button>}
  </nav>
}
